import { Dispatch } from 'redux'
import * as Domain from '../domain'
import { Api } from '../../lib'

interface Data {
  eventsList: Array<Domain.Event.ListEntity>
  currentDate: string
}
type DetailEntity = Domain.Event.DetailEntity
type CheckEventEntiTy = Domain.Event.CheckEventEntiTy

export function fetchEventsList(reloader: () => void, didCallFetchEventsListApi: (data: Data) => void, params = '') {
  const options = {
    reload: reloader,
  }

  return async function(dispatch: Dispatch) {
    await Api.callApi(Api.HttpMethod.get, 'events', params, null, didCallFetchEventsListApi, dispatch, options)
  }
}

export function fetchEvent(reloader: () => void, eventId: string | undefined, didCallFetchEventApi: (data: DetailEntity) => void) {
  const options = {
    reload: reloader,
  }

  return async function(dispatch: Dispatch) {
    await Api.callApi(Api.HttpMethod.get, `events/${eventId}`, '', null, didCallFetchEventApi, dispatch, options)
  }
}
export function fetchEventEntryStatus(reloader: () => void, eventId: string | undefined, didCallFetchCheckEvent: (data: CheckEventEntiTy) => void) {
  const options = {
    reload: reloader,
  }

  return async function(dispatch: Dispatch) {
    await Api.callApi(Api.HttpMethod.get, `user-entry/status`, `&eventId=${eventId}`, null, didCallFetchCheckEvent, dispatch, options)
  }
}

export function registerEvent(body: Domain.Event.PostEventEntity, didCallPostEventApi: () => void) {
  return async function(dispatch: Dispatch) {
    await Api.callApi(Api.HttpMethod.post, 'user-entry', '', JSON.stringify(body), didCallPostEventApi, dispatch)
  }
}
